const mapStateToProps = (state) => {
    const {
        api:{
            geoObjs,
        }={},
        ui:{
            selectedGeoObjArray,
            isShowRouteTooltips
        }={},
        route:{
            routeArr,
            routeSettingsArr,
        }={},
    }=state;
    return {
        geoObjs,
        routeArr,
        routeSettingsArr,
        selectedGeoObjArray,
        isShowRouteTooltips
    }
}

export default mapStateToProps;